export const SECONDS_IN_A_MINUTE = 60



/** WEBPACK FOOTER **
 ** ./src/pomodoro-clock/constants.js
 **/